import { observer } from 'mobx-react'

import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'
import type CustomFieldValue from 'modules/custom_resources/store/models/customFields/Value'

import CustomField from './CustomField'

interface Props {
  customFields: ResourceField[]
  customValues: CustomFieldValue[]
}

const CustomFields = ({ customFields, customValues }: Props) => {
  const orderedCustomFields = customFields
    .slice()
    .sort((a, b) => a.attributes.position - b.attributes.position)

  return (
    <>
      {orderedCustomFields.map((customField) => {
        const customValue = customValues.find(
          (value) => value.attributes.field_id === customField.attributes.field_id
        )

        return (
          <CustomField
            key={customField.attributes.identifier}
            customField={customField}
            customValue={customValue}
          />
        )
      })}
    </>
  )
}

export default observer(CustomFields)
